import AdilQadri from '@library/images/icons/adilqadri.svg'
import Aqualogica from '@library/images/icons/aqualogica.svg'
import Blissclub from '@library/images/icons/blissclub.svg'
import BombayShavingCompany from '@library/images/icons/bombay-shaving-company.svg'
import Foxtale from '@library/images/icons/foxtale.svg'
import Levis from '@library/images/icons/levis.svg'
import Libas from '@library/images/icons/libas.svg'
import McCaffine from '@library/images/icons/mCaffaine.svg'
import Mivi from '@library/images/icons/mivi.svg'
import Plix from '@library/images/icons/plix.svg'
import RareRabbit from '@library/images/icons/rare-rabbit.svg'
import ActInsights from '@library/images/icons/actionable-insights.svg'
import PassFree from '@library/images/icons/password-free-login.svg'
import RecogReturn from '@library/images/icons/recognize-return-shoppers.svg'
import RetargetRecover from '@library/images/icons/retarget-recover.svg'
import SmartPopups from '@library/images/icons/smart-popups.svg'
import KpBanner1 from '@library/images/common/kwikpass-onboarding-images/kp-slide-1.webp'
import KpBanner2 from '@library/images/common/kwikpass-onboarding-images/kp-slide-2.webp'
import KpBanner3 from '@library/images/common/kwikpass-onboarding-images/kp-slide-3.webp'
import KpBanner4 from '@library/images/common/kwikpass-onboarding-images/kp-slide-4.webp'
import KpBanner5 from '@library/images/common/kwikpass-onboarding-images/kp-slide-5.webp'
import KpPoster1 from '@library/images/common/kwikpass-onboarding-images/kp-poster-1.webp'
import KpPoster2 from '@library/images/common/kwikpass-onboarding-images/kp-poster-2.webp'
import KpPoster3 from '@library/images/common/kwikpass-onboarding-images/kp-poster-3.webp'
import CaseStudy1 from '@library/images/common/kwikpass-onboarding-images/case-study-1.webp'
import CaseStudy2 from '@library/images/common/kwikpass-onboarding-images/case-study-2.webp'
import CaseStudy3 from '@library/images/common/kwikpass-onboarding-images/case-study-3.webp'

export const BANNER_LOGOS = [
    AdilQadri,
    Aqualogica,
    Blissclub,
    BombayShavingCompany,
    Foxtale,
    Levis,
    Libas,
    McCaffine,
    Mivi,
    Plix,
    RareRabbit,
]

export const kp_banners = [KpBanner1, KpBanner2, KpBanner3, KpBanner4, KpBanner5]
export const kp_posters = [KpPoster1, KpPoster2, KpPoster3]

// Network Effect Data
export const NETWORK_EFFECT_DATA = [
    {
        value: '25%',
        label: 'of anonymous user\nsessions identified',
    },
    {
        value: '5-10X',
        label: 'increase in ROAS\n(Return on Ad Spend)',
    },
    {
        value: '130Mn+',
        label: 'Shoppers on\nGoKwik network',
    },
]

// Features Data
export const FEATURES_DATA = [
    {
        icon: <img src={ActInsights} />,
        title: 'Password-Free Logins for Instant Access',
        description:
            'Allow customers to quickly log in via OTP—no password needed—for a frictionless and secure shopping experience.',
    },
    {
        icon: <img src={PassFree} />,
        title: 'Recognise Returning Shoppers Instantly',
        description:
            'Identify up to 25% of anonymous shoppers from the GoKwik network of 130Mn+ and authenticate new visitors seamlessly with phone-first logins and fingerprint tracking.',
    },
    {
        icon: <img src={RecogReturn} />,
        title: 'Smart Pop-Ups That Capture Leads & Drive Action',
        description:
            'Engage visitors with behavior-based popups to collect leads, reduce cart abandons, offer personalized discounts, and reduce spin-offs. A/B test different pop-ups to optimize engagement and conversions.',
    },
    {
        icon: <img src={RetargetRecover} />,
        title: 'Actionable Insights with Built-in Compliance',
        description:
            'Track GMV, orders placed, and campaign-driven sessions to gain deep insights into visitor behavior. Create personalized marketing strategies with real-time analytics—all while ensuring GDPR compliance with customizable consent management.',
    },
    {
        icon: <img src={SmartPopups} />,
        title: 'Retarget & Recover Lost Sales with Precision',
        description:
            'Identify anonymous visitors and retarget them across multiple channels using WhatsApp, SMS, and email with Kwik Engage. Recover abandoned carts, drive repeat purchases, and maximize revenue.',
    },
]

export const FAQS = [
    {
        question: 'How does KwikPass identify anonymous users?',
        answer: 'We use advanced fingerprinting combined with phone-first OTP authentication to recognize visitors instantly—even without traditional logins.',
    },
    {
        question: 'Can KwikPass integrate with my e-commerce platform?',
        answer: 'Yes, KwikPass is designed to work seamlessly with Shopify and custom e-commerce solutions.',
    },
    {
        question: 'What are smart marketing pop-ups?',
        answer: 'They are interactive, personalized pop-ups that appear as soon as visitors land on your site, offering discounts and capturing key customer data.',
    },
    {
        question: 'How does the integration with KwikEngage benefit my business?',
        answer: 'It enables targeted retargeting campaigns across multiple channels (WhatsApp, SMS, Email), leading to higher conversions and repeat sales.',
    },
    {
        question: 'Is customer data secure with KwikPass?',
        answer: 'Absolutely. We adhere to industry-best security practices to ensure that your customer data remains fully protected.We are PCI DSS compliant.',
    },
    {
        question: 'Does KwikPass create dummy emails to login users to Shopify?',
        answer: 'No, absolutely not. We have customer email associated with users in our network system. If we don’t find any, then we ask the user for their email upon login to Shopify.',
    },
    {
        question: 'Can I run A/B test with the marketing popups?',
        answer: 'Absolutely. From March, 2025 this feature is available to merchants.',
    },
    {
        question: 'What are the pricing plans for KwikPass?',
        answer: 'Our pricing varies based on the features and usage. Please visit our pricing page or contact our sales team for a customized quote.',
    },
    {
        question: 'Can we remove the KwikPass branding from the popups?',
        answer: 'KwikPass branding cannot be removed from login popup, but can be removed from marketing popup. However, you can customize other elements of the popups, such as colors, messaging, and design, to align with your brand identity.',
    },
    {
        question: 'Is the spin wheel popup customizable?',
        answer: 'Absolutely! You can customize the design, discount values, and messaging on the spin wheel to align with your brand and promotional strategies.',
    },
    {
        question: 'How do we target customers effectively?',
        answer: 'With KwikPass, you can segment customers based on what source they are coming from, past purchases, and engagement patterns. Using smart pop-ups on your website through different stages of their interaction you can target them at the right time with the right offers.Moreover, you can use KwikEngage to target them offline via WhatsApp basis their behavior.',
    },
]

export const case_study_cards = [
    {
        imgSrc: CaseStudy1,
        title: 'Jimmy Luxury Takes A Fashionable Leap Online with GoKwik',
        showLink: true,
        redirectUrl: 'https://www.gokwik.co/success-story/jimmy-luxury-takes-a-fashionable-leap-online-with-gokwik',
    },
    {
        imgSrc: CaseStudy2,
        title: 'Now Identify 20% More Website Traffic With KwikPass',
        showLink: true,
        redirectUrl: 'https://www.gokwik.co/blog/kwikpass',
    },
    {
        imgSrc: CaseStudy3,
        title: 'Valentine’s Day D2C Playbook: Strategies to Increase Sales & ROAS',
        showLink: true,
        redirectUrl: 'https://www.gokwik.co/playbook/valentines-day-d2c-playbook-strategies-to-increase-sales-roas',
    },
]
